import { Id, PagedMultiSelectField, laravelServiceSelectFetchConfig, withOptionsEndpoint } from "@dgs/core";
import { FC } from "react";
import { UserSelectOption } from "./UserSelectOption";

const service = withOptionsEndpoint<{
	id: Id;
	name: string;
	email: string;
}>(["users"]);
const fetchConfig = laravelServiceSelectFetchConfig(service);

interface Props {
	name: string;
	label: string;
	required?: boolean;
	disabled?: boolean;
}

export const UserMultiSelectField: FC<Props> = (props) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={fetchConfig}
			getLabel={(x) => x.name}
			renderOption={(x, isSelected) => <UserSelectOption isSelected={isSelected} user={x} />}
		/>
	);
};
